// Radha — credit / debit notes (Zoho Books style). Read the tenant's notes and
// create new ones; the tenant + note number are set server-side (migration 040).
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export interface CreditNote {
  id: string; note_number: string; note_type: "credit" | "debit";
  customer_name: string; invoice_number: string | null; reason: string | null;
  amount: string; tax_amount: string; status: string; issued_at: string;
}

export interface NewCreditNote {
  note_type: "credit" | "debit"; customer_name: string;
  invoice_number: string | null; reason: string | null;
  amount: number; tax_amount: number;
}

const KEY = ["credit-notes"];

export function useCreditNotes() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<CreditNote[]> => {
      const { data, error } = await supabase
        .from("credit_notes")
        .select("id, note_number, note_type, customer_name, invoice_number, reason, amount, tax_amount, status, issued_at")
        .order("issued_at", { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as CreditNote[];
    },
  });
}

export function useCreateCreditNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (n: NewCreditNote) => {
      const { data, error } = await supabase.from("credit_notes").insert(n).select("id, note_number").single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
